import { auth } from "../../API/Auth";
import { tenant as tenantAPI } from "../../API/UserManagement/Tenant";
import { saveState } from "../../sessionstorage";
import { ReNotification } from "../../unity-ui-common/Components/ReNotification";

export async function workspaceChange(id: any, sessionData: any) {
  const userData = sessionData.userData;
  const userId = userData.id;
  const chosenTenantId = id;
  const workspace = userData?.tenants?.find(
    (each: Record<string, any>) => each?.id === chosenTenantId
  );
  if (!workspace) return;

  const resp = await auth.loginWithTenant({
    user: userId,
    tenantId: chosenTenantId,
  });

  if (!resp || !resp.accessToken) {
    ReNotification({
      description: "There is no role attached to this user",
      type: "error",
    });
    return {};
  }

  // Pull the tenant's *current* configuration from the server so the selected
  // workspace always carries the latest dataEntryMode (and other configs),
  // even if it changed after the user logged in. Falls back to the login-time
  // workspace object if the fetch fails.
  let selectedTenant = workspace;
  try {
    const fresh = await tenantAPI.getTenant(chosenTenantId);
    const freshTenant =
      fresh?.data?.[0]?.org || fresh?.data?.[0]?.orgs || fresh?.data || fresh;
    if (freshTenant?.id) {
      selectedTenant = { ...workspace, ...freshTenant };
    }
  } catch (e) {
    // keep the login-time workspace object on failure
  }

  await saveState({
    selectedTenantId: chosenTenantId,
    selectedTenant,
    userAccessToken: resp?.accessToken || "",
    userPermissions: resp?.userPermissions || [],
  });

  const permArr = (Array.isArray(resp?.userPermissions) ? resp.userPermissions : []).map((each: any) => String(each?.type));

  // Base the redirect on genuinely assigned privileges. A pure SUPER_ADMIN
  // (type 20 only) lands on /home, but a user who genuinely holds a
  // Notifications privilege ("5"/"6") — even alongside SUPER_ADMIN — goes to
  // the notifications inbox. permArr already excludes SUPER_ADMIN's implicit
  // expansion, so no explicit isSuperAdmin check is needed.
  return {
    endPoint:
      permArr.includes("5") || permArr.includes("6")
        ? "/notifications"
        : "/home",
    // Returned so callers can push this straight into Redux (the app navigates
    // via SPA routing, not a full reload, so Redux must be updated explicitly).
    selectedTenant,
    selectedTenantId: chosenTenantId,
    userAccessToken: resp?.accessToken || "",
    userPermissions: resp?.userPermissions || [],
  };
}
